module.exports = __webpack_public_path__ + "a0b262601f141229fd34aedab4665000.png";


//////////////////
// WEBPACK FOOTER
// ./src/HomePage/yelp5.png
// module id = 1895
// module chunks = 0